export default __webpack_public_path__ + "static/media/horizontal-dotted-line.c31bc53d.svg";